import React, { Fragment } from "react";
import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";
import Navbar from "../../components/Navbar/Navbar";
import Hero2 from "../../components/hero2/Hero2";
import About2 from "../../components/about2/about2";
import PillarsSection from "../../components/PillarsSection/PillarsSection";
import ServiceSectionS2 from "../../components/ServiceSectionS2/ServiceSectionS2";
import FunFact from "../../components/FunFact/FunFact";
import EventSectionS2 from "../../components/EventSectionS2/EventSectionS2";
import PrayerTime from "../../components/PrayerTime/PrayerTime";
import Footer from "../../components/footer/Footer";
import Scrollbar from "../../components/scrollbar/scrollbar";
import MapLocation from "../../components/mapsLocation/MapLocation";
import KidsSchedule from "../../components/KidsSchedule/KidsSchedule";
import ProgramIntro from "../../components/ProgramIntro/ProgramIntro";
import ProgramAnnouncement from "../../components/ProgramAnnouncement/ProgramAnnouncement";
import HistorySection from "../../components/road-map/HistorySection";
import JourneyTimeline from "../../components/road-map/JourneyTimeline";
import { academicYear } from "../../data/programs";

const HomePage2 = () => {
  const { t } = useTranslation("home");
  const { gregorianYear, startDate } = academicYear;

  // Structured data for the season opening, so search engines can surface the
  // start date next to the result.
  const eventSchema = {
    "@context": "https://schema.org",
    "@type": "EducationEvent",
    name: t("programme.announcement.title", { year: gregorianYear }),
    startDate,
    eventAttendanceMode: "https://schema.org/OfflineEventAttendanceMode",
    eventStatus: "https://schema.org/EventScheduled",
    organizer: {
      "@type": "EducationalOrganization",
      name: "دار محمد عطاوي",
      url: "https://www.darattaoui.ma",
    },
    location: {
      "@type": "Place",
      name: "دار محمد عطاوي",
      address: {
        "@type": "PostalAddress",
        streetAddress: "J3 CYM",
        addressLocality: "Rabat",
        postalCode: "10130",
        addressCountry: "MA",
      },
    },
  };

  return (
    <Fragment>
      <Helmet>
        <title>{t("seo.title", { year: gregorianYear })}</title>
        <meta
          name="description"
          content={t("seo.description", { year: gregorianYear })}
        />
        <meta
          property="og:title"
          content={t("seo.title", { year: gregorianYear })}
        />
        <meta
          property="og:description"
          content={t("seo.description", { year: gregorianYear })}
        />
        <script type="application/ld+json">{JSON.stringify(eventSchema)}</script>
      </Helmet>
      <Navbar hclass={"wpo-header-style-4"} />
      <div className="snap-page">
        <Hero2 />
        <PrayerTime prClass={"prayertime-section-s2"} />
        <About2 />
        <PillarsSection plClass={"pillars-section-s2"} />
        <ServiceSectionS2 />
        <FunFact fnClass={"funfact-section-s2"} />
        <JourneyTimeline />
        <HistorySection />
        <EventSectionS2 />
        <ProgramAnnouncement />
        <ProgramIntro />
        {/* <Testimonial />
        <BlogSection /> */}
        <KidsSchedule />
        <MapLocation />
        <Footer ftClass={"s2"} />
      </div>
      <Scrollbar />
    </Fragment>
  );
};
export default HomePage2;
